module.exports = __webpack_public_path__ + "static/media/section-1.91b127f5.png";